import * as React from 'react'
import IconPanel from '@mulesoft/anypoint-icons/lib/Icon'
import './Banner.css'

export type ValueProps = {
  type: 'info' | 'warning'
}

export type EventProps = {
  onClick?: () => void
}

export type Props = ValueProps & EventProps

export const Banner: React.StatelessComponent<Props> = props => {
  const bannerTypeClassName = `built-in-${props.type}-banner`
  const containerClassName = `built-in-banner ${bannerTypeClassName}`
  const iconClassName = 'built-in-banner-icon'
  const iconSize = 25
  const iconFill = '#FFF'
  const iconName = `${props.type}-small`

  return (
    <div onClick={props.onClick} className={containerClassName}>
      <IconPanel className={iconClassName} name={iconName} size={iconSize} fill={iconFill}/>
      <p>{props.children}</p>
    </div>
  )
}
